import { apiClient } from './apiClient';
import type {
  AudienceStaffOptionDto,
  DesktopNotificationCreateRequestDto,
  DesktopNotificationDetailDto,
  DesktopNotificationListItemDto,
  DesktopNotificationPlaceholdersDto,
  DesktopNotificationType,
  DesktopNotificationUpdateRequestDto,
} from './types/desktopNotification.types';

export const desktopNotificationApi = {
  getAll: async (enabled?: boolean): Promise<DesktopNotificationListItemDto[]> => {
    const params = enabled !== undefined ? { enabled } : undefined;
    const res = await apiClient.get<DesktopNotificationListItemDto[]>(
      '/desktop-notifications',
      { params },
    );
    return res.data;
  },

  getById: async (id: number): Promise<DesktopNotificationDetailDto> => {
    const res = await apiClient.get<DesktopNotificationDetailDto>(
      `/desktop-notifications/${id}`,
    );
    return res.data;
  },

  create: async (
    request: DesktopNotificationCreateRequestDto,
  ): Promise<DesktopNotificationDetailDto> => {
    const res = await apiClient.post<DesktopNotificationDetailDto>(
      '/desktop-notifications',
      request,
    );
    return res.data;
  },

  update: async (
    id: number,
    request: DesktopNotificationUpdateRequestDto,
  ): Promise<DesktopNotificationDetailDto> => {
    const res = await apiClient.put<DesktopNotificationDetailDto>(
      `/desktop-notifications/${id}`,
      request,
    );
    return res.data;
  },

  delete: async (id: number, rowVersion: string): Promise<void> => {
    await apiClient.delete(`/desktop-notifications/${id}`, {
      params: { rowVersion },
    });
  },

  // Omitting the type returns every token, which is what the create form needs before a type is picked.
  getPlaceholders: async (
    type?: DesktopNotificationType | null,
  ): Promise<DesktopNotificationPlaceholdersDto> => {
    const res = await apiClient.get<DesktopNotificationPlaceholdersDto>(
      '/desktop-notifications/placeholders',
      { params: type ? { type } : undefined },
    );
    return res.data;
  },

  getAudienceStaffOptions: async (
    type?: DesktopNotificationType | null,
  ): Promise<AudienceStaffOptionDto[]> => {
    const res = await apiClient.get<AudienceStaffOptionDto[]>(
      '/desktop-notifications/audience-staff-options',
      { params: type ? { type } : undefined },
    );
    return res.data;
  },
};
